// https://developers.google.com/analytics/devguides/migration/ua/analyticsjs-to-gtagjs
// https://developers.google.com/analytics/devguides/collection/analyticsjs/creating-trackers

const GoogleAdaptor = (adaptorPayload) => {
  // This adaptors retrieves a name property from the window.ga object and then bundles this information with event properties
  // Then the google analytics client handles the bundle.
  // .get() and .getAll() are google analytics client methods and not associated with any library.

  // Google Analytics support & documentation
  // https://developers.google.com/analytics/
  // https://support.google.com/analytics/?hl=en#topic=3544906

  if ( adaptorPayload.analyticsEvent.name !== 'site-page-view' ){
    const gtag = window.gtag;
    const dataLayer = window.dataLayer;

    if (gtag) {
      gtag('event', adaptorPayload.analyticsEvent.name, {
        'event_category': adaptorPayload.analyticsEvent.category,
      });
    }

    if (dataLayer) {
      dataLayer.push({'event': adaptorPayload.analyticsEvent.name, 'event_category': adaptorPayload.analyticsEvent.category,})
    }

    const client = window.ga;
    if (client) {
      let trackers = client.getAll();
      let name;
      for (let tracker in trackers) {
        name = trackers[tracker].get('name');
        client( name + '.send', 'event', adaptorPayload.analyticsEvent.category, adaptorPayload.analyticsEvent.name );
      }
      // For npm testing
      // Because google analytics may use multiple trackers can not return client() so it returns an array with the last retrieved name
      return [ name + '.send', 'event', adaptorPayload.analyticsEvent.category, adaptorPayload.analyticsEvent.name ];
    }
  }
}

export { GoogleAdaptor }
